import React from 'react';
import iconSign from '../../assets/svg/icon-sign.svg';
import iconHeartRate from '../../assets/svg/icon-heartrate.svg';
import iconCheckup from '../../assets/svg/icon-checkup.svg';
import iconHospital from '../../assets/svg/icon-hospital.svg';
import iconCheck from '../../assets/svg/icon-check.svg';
import iconOnline from '../../assets/svg/icon-online.svg';

const reasonsGovernment = (props) => {
  const findADoc = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'eventCategory': 'Click',
      'eventAction': 'Load Website',
      'eventLabel': 'Find a Doc',
      'eventValue': undefined
    });
  };
  let searchLink = (props.search) ? props.search : 'https://findadoc.cdphp.com/';

  return (
    <section className='divide p60'>
      <div className='wrap'>
        <h2>A few reasons why you&rsquo;ll&nbsp;love&nbsp;us.</h2>
        <ul className='three-col reasons'>
          <li className='col'>
            <span><img src={iconSign} alt='Sign up any time. There&rsquo;s no open enrollment period' className='sign' /></span>
            <p>Sign up any time. There&rsquo;s no open enrollment period</p>
          </li>
          <li className='col'>
            <span><img src={iconHeartRate} alt='Checkups, flu shots, and other preventive care at no cost to you' /></span>
            <p>Checkups, flu shots, and other preventive care at no cost to you</p>
          </li>
          <li className='col'>
            <span><img src={iconHospital} alt='Access to most local doctor and Hospitals' /></span>
            <p>Access to most local doctors<br /> and hospitals (
              <a href={searchLink}
                target='_blank'
                rel='noopener noreferrer'
                onClick={findADoc}>search now</a>)</p>
          </li>
          <li className='col'>
            <span><img src={iconCheck} alt='Pre-existing conditions' /></span>
            <p>Coverage for any and all<br /> pre-existing conditions</p>
          </li>
          <li className='col'>
            <span><img src={iconOnline} alt='Ability to see a doctor online' /></span>
            <p>Ability to see a doctor online<br /> from the comfort of home</p>
          </li>
          <li className='col'>
            <span><img src={iconCheckup} alt='Help Booking Appointments' /></span>
            <p>Get help booking appointments</p>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default reasonsGovernment;
